import { syncPaletteToCssVars } from '@theme/cssVars'
import { syncPaletteToLegacyCssVars } from '@theme/legacyCssVars'
import {
  presetPaletteFromId,
  readStoredThemePresetId,
} from '@theme/themePresets'

/** Gọi trước `createRoot`: tránh nháy màu trước khi Provider mount */
export function bootstrapStoredThemeAppearance(): void {
  const palette = presetPaletteFromId(readStoredThemePresetId())
  syncPaletteToCssVars(palette as unknown as Record<string, unknown>)
  syncPaletteToLegacyCssVars(palette)
}
